export type CardDetails = {
  value: 0; // Change price of all cards to 0 - Petros
  items: [
    {
      item_id: string;
      item_name: string;
      item_category: string;
      item_category2: string;
      price: number;
      quantity: number;
    }
  ];
};

export const AIBGADetails: CardDetails = {
  value: 0,
  items: [
    {
      item_id: "i_AIB",
      item_name: "Avion Visa Infinite Business",
      item_category: "business_credit_cards",
      item_category2: "avion",
      price: 0,
      quantity: 1
    }
  ]
};

export const MC6GADetails: CardDetails = {
  value: 0,
  items: [
    {
      item_id: "i_MC6",
      item_name: "Business Cashback Mastercard",
      item_category: "business_credit_cards",
      item_category2: "cashback",
      price: 0,
      quantity: 1
    }
  ]
};

export const CPXGADetails: CardDetails = {
  value: 0,
  items: [
    {
      item_id: "i_CPX",
      item_name: "Avion Visa Business",
      item_category: "business_credit_cards",
      item_category2: "avion",
      price: 0,
      quantity: 1
    }
  ]
};

export const CLXGADetails: CardDetails = {
  value: 0,
  items: [
    {
      item_id: "i_CLX",
      item_name: "Visa Business",
      item_category: "business_credit_cards",
      item_category2: "other",
      price: 0,
      quantity: 1
    }
  ]
};
